import React from 'react';
import PropTypes from 'prop-types';

export default class Accordion extends React.Component {

  render() {
    return (
      <div className="panel-group" id={this.props.id} role="tablist" aria-multiselectable="true">
        {this.props.children}
      </div>
    );
  }

}

Accordion.propTypes = {
  id: PropTypes.string,
};

Accordion.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/shared/components/accordion/Accordion.js